import { NavLink, Outlet, useNavigate } from "react-router-dom";
import {
  LayoutDashboard,
  Users,
  Sparkles,
  History,
  UserCircle,
  LogOut,
} from "lucide-react";
import { useAuth } from "@/context/AuthContext";

const ADMIN_NAV = [
  { to: "/admin", label: "Overview", icon: LayoutDashboard, end: true },
  { to: "/admin/practitioners", label: "Practitioners", icon: Users },
];

const PRACT_NAV = [
  { to: "/practitioner", label: "Ritual Hub", icon: Sparkles, end: true },
  { to: "/practitioner/history", label: "History", icon: History },
  { to: "/practitioner/profile", label: "Profile", icon: UserCircle },
];

export default function AppLayout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const nav = user?.role === "admin" ? ADMIN_NAV : PRACT_NAV;

  const handleLogout = () => {
    logout();
    navigate("/login", { replace: true });
  };

  const linkClass = ({ isActive }) =>
    `flex items-center gap-3 rounded-xl px-4 py-3 text-sm font-medium transition-colors ${
      isActive
        ? "bg-soma-brand/15 text-soma-brand"
        : "text-soma-on2 hover:bg-soma-surface3 hover:text-soma-on"
    }`;

  return (
    <div className="flex min-h-screen bg-soma-surface text-soma-on">
      {/* Desktop sidebar */}
      <aside className="hidden w-64 shrink-0 flex-col border-r border-soma-border bg-soma-surface2 p-5 md:flex">
        <div className="mb-10 px-2">
          <p className="font-display text-3xl italic tracking-wide text-soma-brand">
            Soma Linea
          </p>
          <p className="mt-1 font-mono text-[11px] uppercase tracking-[0.25em] text-soma-muted">
            {user?.role === "admin" ? "// keeper" : "// practitioner"}
          </p>
        </div>
        <nav className="flex flex-1 flex-col gap-1">
          {nav.map((n) => (
            <NavLink key={n.to} to={n.to} end={n.end} className={linkClass} data-testid={`nav-${n.label.toLowerCase()}`}>
              <n.icon size={18} />
              {n.label}
            </NavLink>
          ))}
        </nav>
        <div className="mt-4 border-t border-soma-border pt-4">
          <p className="truncate px-2 text-sm text-soma-on">{user?.full_name}</p>
          <p className="truncate px-2 text-xs text-soma-muted">{user?.email}</p>
          <button
            onClick={handleLogout}
            data-testid="logout-button"
            className="mt-3 flex w-full items-center gap-3 rounded-xl px-4 py-3 text-sm font-medium text-soma-on2 transition-colors hover:bg-soma-error/20 hover:text-soma-on"
          >
            <LogOut size={18} /> Sign out
          </button>
        </div>
      </aside>

      {/* Main content */}
      <main className="flex-1 pb-24 md:pb-0">
        <Outlet />
      </main>

      {/* Mobile bottom tab bar */}
      <nav className="fixed bottom-0 left-0 right-0 z-30 flex border-t border-soma-border bg-soma-surface2/95 backdrop-blur md:hidden">
        {nav.map((n) => (
          <NavLink
            key={n.to}
            to={n.to}
            end={n.end}
            data-testid={`tab-${n.label.toLowerCase()}`}
            className={({ isActive }) =>
              `flex flex-1 flex-col items-center gap-1 py-3 text-[11px] ${
                isActive ? "text-soma-brand" : "text-soma-muted"
              }`
            }
          >
            <n.icon size={20} />
            {n.label}
          </NavLink>
        ))}
      </nav>
    </div>
  );
}
